<template>
	<pagina-erro
		titulo="Acesso bloqueado"
		icone="fa fa-hand-paper-o"
		imagemTexto="centralservidor-logo-texto.png"
		imagem="centralservidor-logo.png"
		texto="Você não possui acesso a essa página.
			Verifique suas permissões de acesso com seu superior." >
	</pagina-erro>
</template>

<script >
import PaginaErro from '@/components/pagina-erro'

export default {
	name: 'SemAcesso',
	components: {
		PaginaErro
	}
}
</script>




// WEBPACK FOOTER //
// index.vue?bed79e1c